import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ZapierLogo = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8302 10.2417H15.9163L20.0719 6.08605C19.7522 5.60663 19.4325 5.28692 19.1128 4.8072C18.6528 4.47474 18.2248 4.10018 17.8342 3.68836L13.6792 7.84431V2.09043C13.1573 1.95832 12.6187 1.9045 12.081 1.93073C11.5429 1.89604 11.0027 1.94999 10.4821 2.09043V8.00432L6.16677 3.68899C5.67058 3.9734 5.23587 4.35361 4.88792 4.80751C4.56821 5.28692 4.0888 5.60663 3.76909 6.08636L7.9244 10.2417H2.17084L2.01114 11.8399C1.97652 12.3778 2.03047 12.9178 2.17084 13.4382H8.08505L3.76972 17.7535C4.40116 18.7043 5.21624 19.5194 6.16709 20.1509L10.3227 15.9952V21.9094C10.8446 22.0415 11.3832 22.0954 11.921 22.0691C12.4589 22.1038 12.9988 22.0498 13.5192 21.9094V15.9959L17.6745 20.1518C18.1706 19.8673 18.6052 19.487 18.9531 19.033C19.3649 18.6424 19.7394 18.2144 20.0719 17.7544L15.9163 13.5982H21.8302C21.9624 13.0763 22.0163 12.5377 21.9902 11.9999C22.024 11.4092 21.9699 10.8167 21.8302 10.2417ZM14.4777 11.8399C14.4618 12.5435 14.3544 13.2421 14.158 13.9179C13.4975 14.1769 12.7878 14.2861 12.08 14.2376C11.3764 14.2217 10.6779 14.1142 10.0021 13.9179C9.74308 13.2574 9.63389 12.5477 9.68235 11.8399C9.69823 11.1363 9.80571 10.4378 10.0021 9.76195C10.6625 9.50297 11.3723 9.39377 12.08 9.44224C12.7836 9.45812 13.4822 9.56559 14.158 9.76195C14.3424 10.4404 14.4496 11.1374 14.4777 11.8399Z"
          fill="#FF4A00"
        />
      </svg>
    )
  },
)

export default ZapierLogo
